import React from 'react'
import { Bar } from 'react-chartjs-2'

const DoubleBarChart = ({ target, sales }) => {
  const data = {
    labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
    datasets: [
      {
        label: 'Target',
        data: target,
        backgroundColor: 'rgb(255, 99, 132)',
      },
      {
        label: 'Sales',
        data: sales,
        backgroundColor: 'rgb(54, 162, 235)',
      },
    ],
  }

  const options = {
    legend: {
      display: true,
      position: 'bottom',
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  }
  return (
    <>
      <Bar data={data} options={options} />
    </>
  )
}

export default DoubleBarChart
